export default "<lib-relatorio-personalizado-shw [(modulos)]=\"modulos\" (systemChange)=\"changeSelectedSystem($event)\"></lib-relatorio-personalizado-shw>";